module.exports = __webpack_public_path__ + "img/shuttle-central-logo.564f76f3.svg";